<template>
  <EventsListWithFiltersWrapper
    :title="$t('events.my_events')"
    :event-type="EventType.Default"
    :list-type="EventsListTypeMap.Me"
  >
    <template #empty>
      <div class="flex flex-col gap-2 h-full justify-center items-center py-8">
        <template v-if="authStore.auth">
          <template v-if="eventsStore.filtersCount > 0">
            {{ $t('events.no_events_with_filters') }}
          </template>
          <template v-else>
            <div>
              {{ $t('events.no_my_events') }}
            </div>
            <BaseLink :to="'/events'" class="block">
              {{ $t('events.upcoming_events') }}
            </BaseLink>
          </template>
        </template>
        <template v-else>
          <div class="mb-2">
            {{ $t('events.login_to_see_my_events') }}
          </div>
          <BaseButton
            theme="primary"
            look="border"
            @click="authStore.openLoginModal"
          >
            {{ $t('header.login') }}
          </BaseButton>
        </template>
      </div>
    </template>
  </EventsListWithFiltersWrapper>
</template>

<script setup lang="ts">
import { useAuth } from '~/stores/auth'
import { useEvents } from '~/stores/events'
import { EventType, EventsListTypeMap } from '~/models/events'

const authStore = useAuth()
const eventsStore = useEvents()

definePageMeta({
  alias: ['/my-events'],
})

useHeadMeta(
  {
    title: 'My events',
    description:
      'Game industry conferences, networking events, and summits around the world, including UK, China, Turkey, US, Canada, and EU',
  },
  { canonical: 'https://wnhub.io/event-info/my' }
)
</script>
